import type { PropsWithChildren, ReactNode } from 'react';
import React from 'react';

import { SrOrderLineStatus, SrSalesOrderType } from '@plato/data/starrocks/types';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { Badge } from '../../list-views/components/badge';

type Props = {
    status: SrOrderLineStatus;
    type: SrSalesOrderType;
    className?: string;
    children?: ReactNode;
} & PropsWithChildren;

export const LineItemStatusBadge: React.FC<Props> = ({ status, type, children, className }) => {
    const { t } = useLocale('order-status');
    const colour = getOrderLineStatusColor(type, status);

    return (
        <Badge color={colour} className={className}>
            {children ?? (status && t(status))}
        </Badge>
    );
};

type StatusColor = 'yellow' | 'orange' | 'green' | 'red' | 'blue' | 'neutral';

function getOrderLineStatusColor(type: SrSalesOrderType, status: SrOrderLineStatus): StatusColor {
    if (type === SrSalesOrderType.QUOTE) {
        switch (status) {
            case SrOrderLineStatus.LOST:
                return 'red';
            case SrOrderLineStatus.OPEN:
                return 'yellow';
            case SrOrderLineStatus.PARTIALLY_RECEIVED:
                return 'blue';
            case SrOrderLineStatus.RECEIVED:
                return 'green';
            default:
                return 'neutral';
        }
    }
    switch (status) {
        case SrOrderLineStatus.BILLED:
        case SrOrderLineStatus.PROCESSED_INTERNALLY:
            return 'green';
        case SrOrderLineStatus.OPEN:
            return 'red';
        case SrOrderLineStatus.RELEASED_FOR_BILLING:
            return 'blue';
        default:
            return 'neutral';
    }
}
